export const emailTemplateContentStringRegex = /\${\((.*?)\)(.*?)"}/g;

export const EMAIL_TEMPLATE_SUBJECT_VARIABLE_NAME = "subject";
export const EMAIL_TEMPLATE_URL_VARIABLE_NAME = "url";

export const EMAIL_TEMPLATE_REQUIRED_URL_VARIABLE = `\${(${EMAIL_TEMPLATE_URL_VARIABLE_NAME})!"URL_ERROR"}`;

export const DEFAULT_EMAIL_TEMPLATE = `<html>
    <body>
        Click on this <a href='\${(${EMAIL_TEMPLATE_URL_VARIABLE_NAME})!"URL_ERROR"}'>link</a> to begin the verification process.
    </body>
</html>`;
    
export const REQUIRED_EMAIL_TEMPLATE_VARIABLES = [
    EMAIL_TEMPLATE_URL_VARIABLE_NAME,
    EMAIL_TEMPLATE_SUBJECT_VARIABLE_NAME
];